export default "__VITE_ASSET__DQrZ1i8m__"